export default {"src":"/_next/static/media/profile-pro.23d93088.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};